/* eslint-disable default-param-last */
import {
  SET_USER_PROFILE,
  CLEAR_USER_PROFILE,
  SET_USER_PERMISSION,
  CLEAR_USER_PERMISSION
} from '@/application/redux/types.d';

const initailState = {
  profile: null,
  permission: null
};

const user = (state = initailState, action: any) => {
  switch (action.type) {
    case SET_USER_PROFILE:
      return {
        ...state,
        profile: action.profile
      };

    case CLEAR_USER_PROFILE:
      return {
        ...state,
        profile: null
      };

    case SET_USER_PERMISSION:
      return {
        ...state,
        permission: action.permission
      };

    case CLEAR_USER_PERMISSION:
      return {
        ...state,
        permission: null
      };

    default:
      return state;
  }
};

export default user;